import React from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import {
    StyledClose,
    StyledContent,
    StyledOverlay,
    StyledTrigger,
    Form,
    Header,
    SectionBox,
    SendButton,
    SendButtonContainer,
    TitleHeader,
    AiFillCloseCircleIcon
} from './styles';

import { FormEvent, useState } from 'react';

interface IDeclineAnswerProps {
    onDeclineAnswer: (content: string) => void
}

const DeclineAnswer: React.FC<IDeclineAnswerProps> = ({ onDeclineAnswer }: IDeclineAnswerProps) => {

    const [open, setOpen] = useState<boolean>(false);
    const [declineText, setDeclineText] = useState("");

    function handleSubmitButton(event: FormEvent) {
        event.preventDefault();
        onDeclineAnswer(declineText);
        setOpen(false);
    }

    return (
        <Dialog.Root open={open} onOpenChange={setOpen}>
            <StyledTrigger>
                Recusar solução
            </StyledTrigger>

            <Dialog.Portal>
                <StyledOverlay />
                <StyledContent>
                    <StyledClose>
                        <AiFillCloseCircleIcon />
                    </StyledClose>

                    <Header>
                        <TitleHeader>
                            Recusar solução
                        </TitleHeader>
                    </Header>
                    <Form
                        onSubmit={handleSubmitButton}
                    >
                        <SectionBox>
                            <label htmlFor="refuseReasson">
                                Porque você não aprova a solução?
                            </label>
                            <textarea
                                name="refuseReasson"
                                id="refuseReasson"
                                cols={30}
                                rows={10}
                                onChange={(e) => setDeclineText(e.target.value)}
                                required
                            />
                        </SectionBox>
                        <SendButtonContainer>
                            <SendButton>
                                Enviar
                            </SendButton>
                        </SendButtonContainer>
                    </Form>

                </StyledContent>
            </Dialog.Portal>

        </Dialog.Root>
    )

}

export default DeclineAnswer;